import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { SiteLayout, useSEO } from "./shared";

// Presentational-only 404 body — no hook calls here, so ServiceDetail/DistrictDetail can render
// this directly (with their own useSEO noindex call already made) for invalid slugs, without
// ever calling useSEO twice for the same mounted route component.
export function NotFoundContent() {
  return (
    <section className="max-w-3xl mx-auto px-6 py-28 text-center" data-testid="not-found-page">
      <p className="text-primary font-heading font-black text-6xl">404</p>
      <h1 className="mt-4 font-heading font-bold text-2xl sm:text-3xl text-secondary">This page could not be found.</h1>
      <p className="mt-3 text-muted-foreground">The page you're looking for may have moved. Head back to the homepage or get in touch with our team.</p>
      <div className="mt-8 flex flex-wrap gap-3 justify-center">
        <Link to="/"><Button className="rounded-sm bg-primary hover:bg-primary/90" data-testid="notfound-home-btn">BACK TO HOME</Button></Link>
        <Link to="/contact"><Button variant="outline" className="rounded-sm" data-testid="notfound-contact-btn">CONTACT US</Button></Link>
      </div>
    </section>
  );
}

export default function NotFound() {
  useSEO("Page Not Found | SecureFlame Fire Systems", "The page you're looking for could not be found on the SecureFlame Fire Systems website.", { noindex: true });
  return (
    <SiteLayout>
      <NotFoundContent />
    </SiteLayout>
  );
}
